import CustomFormControl from "@/components/Form/FormControl/CustomFormControl";
import { formFieldError } from "@/types";
import labelRequired from "@/utils/labelRequired";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import * as React from "react";
import {
  FieldValues,
  UseControllerProps,
  useController,
} from "react-hook-form";
const toggleButtonList: item[] = [
  {
    label: "Active",
    value: "active",
    color: "success",
  },
  {
    label: "Inactive",
    value: "inactive",
    color: "error",
  },
];
export default function CustomToggleButton<T extends FieldValues>({
  stateType = "uncontrolled",
  controlledDefaultValue,
  name,
  control,
  error,
  label = null,
  required,
  size,
  itemList,
}: CustomToggleButtonProps<T>) {
  const [alignment, setAlignment] = React.useState(
    controlledDefaultValue ?? ""
  );
  const { field } = useController({
    control,
    name,
  });
  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string
  ) => {
    setAlignment(newAlignment);
  };
  const props =
    stateType === "controlled"
      ? {
          value: alignment,
          onchange: handleChange,
        }
      : {
          ...field,
        };
  const list = itemList ?? toggleButtonList;
  return (
    <CustomFormControl label={labelRequired(label, required)} error={error}>
      <ToggleButtonGroup
        color={"primary"}
        exclusive
        {...props}
        aria-label="Platform"
        size={size}
        sx={{ ...(label ? { marginTop: "36px" } : {}) }}
      >
        {list.map((item) => {
          return (
            <ToggleButton
              key={item.value}
              value={item.value}
              color={item.color}
            >
              {item.label}
            </ToggleButton>
          );
        })}
      </ToggleButtonGroup>
    </CustomFormControl>
  );
}

type ButtonColor =
  | "error"
  | "primary"
  | "standard"
  | "secondary"
  | "info"
  | "success"
  | "warning";

export interface item {
  label: string;
  value: string;
  color?: ButtonColor;
}
interface CustomToggleButtonProps<T extends FieldValues = FieldValues>
  extends UseControllerProps<T> {
  stateType?: "uncontrolled" | "controlled";
  controlledDefaultValue?: string;
  error?: formFieldError;
  label?: string | null;
  required?: boolean;
  size?: "small" | "large" | "medium";
  itemList?: item[];
}
